export default __webpack_public_path__ + "static/media/mobile-navigation-menu.f6e67d07.svg";